import frFR from './fr-FR'

export default {
  'fr-FR': frFR
}
